import React, { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "../supabase";
import { useAuth } from "./AuthContext";
import { PLAN_ORDER } from "../constants/plans";

const SubscriptionContext = createContext(null);

export function SubscriptionContextProvider({ children }) {
  const { currentUser } = useAuth();
  const [profile, setProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      setProfile(null);
      setProfileLoading(false);
      return;
    }

    if (!supabase) {
      setProfileLoading(false);
      return;
    }

    setProfileLoading(true);

    const fetchProfile = async () => {
      const { data } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", currentUser.id)
        .single();
      setProfile(data);
      setProfileLoading(false);
    };

    fetchProfile();

    const channel = supabase
      .channel("profile-changes")
      .on(
        "postgres_changes",
        { event: "UPDATE", schema: "public", table: "profiles", filter: `id=eq.${currentUser.id}` },
        (payload) => setProfile(payload.new)
      )
      .subscribe();

    return () => supabase.removeChannel(channel);
  }, [currentUser]);

  const hasFeature = (requiredPlan) => {
    const userPlanIndex = PLAN_ORDER.indexOf(profile?.plan || "free");
    const requiredIndex = PLAN_ORDER.indexOf(requiredPlan);
    return userPlanIndex >= requiredIndex;
  };

  return (
    <SubscriptionContext.Provider value={{ profile, profileLoading, hasFeature }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export const useSubscription = () => useContext(SubscriptionContext);
